import { STEP } from '../@types/state'
import { ProgressType, ValuationBarProgress } from '../@types/valuationBarProgress'

export const DEFAULT_PROGRESS_VALUATION = { previousBound: 0, currentBound: 0 }

const richValuationProgressBarMap: ProgressType = {
  [STEP.ADDRESS]: { previousBound: 100, currentBound: 80 },
  [STEP.CONSTRUCTION_YEAR]: { previousBound: 80, currentBound: 60 },
  [STEP.REAL_ESTATE_SUBTYPE]: { previousBound: 60, currentBound: 40 },
  [STEP.FURNISHING_TYPE]: { previousBound: 40, currentBound: 20 },
}
export const richValuationFlowProgress = (step: STEP): ValuationBarProgress => {
  const element = richValuationProgressBarMap[step]
  if (element) {
    return element
  }
  return DEFAULT_PROGRESS_VALUATION
}
